<template>
    <div class="px-3 mt-4">
        <div class="mt-3 mb-8 space-y-2 max-w-7xl mx-auto">
            <div class="flex items-center justify-between bg-gray-50 py-2 px-3">
                <h4 class="text-lg text-center font-medium">Event #{{ id }}</h4>
                <div class="flex space-x-4 justify-end">
                    <button
                        class="group flex items-center justify-center border text-red-800 border-red-500 hover:text-white hover:bg-red-500 text-sm rounded px-6 py-2 focus:outline-none focus:shadow-outline"
                        @click="deleteModalOpen = true"
                    >
                        <svg
                            class="w-5 h-5 group-hover:text-red-100 text-red-300 mr-1"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                            ></path>
                        </svg>
                        Delete
                    </button>
                </div>
            </div>
            <div v-if="getEvent">
                <modal @close="closeDeleteModal" :closable="!deleting" :open="deleteModalOpen">
                    <div slot="header">
                        <h2 class="pt-2 text-xl font-semibold text-red-600">
                            Delete Event #{{ getEvent.id }}
                        </h2>
                    </div>
                    <div slot="content">
                        <form class="mt-4" @submit.prevent="deleteEvent">
                            <p class="bg-red-100 rounded-sm px-3 py-4">
                                Are you sure you want to delete event id #{{ getEvent.id }}.
                                <br />
                                <span class="uppercase tracking-wide text-sm font-medium"
                                    >This action cannot be reversed!!</span
                                >
                            </p>
                            <p v-if="!!deleteError" class="my-2 error-msg">{{ deleteError }}</p>
                            <div class="px-2 mt-6 mb-2 flex justify-between">
                                <Button
                                    :disabled="deleting"
                                    @click="closeDeleteModal"
                                    class="bg-gray-200 hover:bg-white hover:border-gray-800 border border-transparent px-6 py-2 rounded"
                                    type="button"
                                    label="Cancel"
                                />
                                <Button
                                    :disabled="deleting"
                                    :loading="deleting"
                                    class="bg-red-500 hover:bg-red-600 text-white px-6 py-2 rounded"
                                    label="Yes Delete"
                                />
                            </div>
                        </form>
                    </div>
                </modal>
            </div>
            <div>
                <pre><code>{{ JSON.stringify(getEvent, null, 1) }}</code></pre>
            </div>
        </div>
    </div>
</template>
<script>
import gql from 'graphql-tag'
const EVENT_QUERY = gql`
    query GetEvent($id: Int!) {
        getEvent(id: $id) {
            id
            sender
            toUserId
            eventType
            readAt
            detailJson
            createdAt
        }
    }
`
export default {
    methods: {
        closeDeleteModal() {
            this.deleteModalOpen = false
            this.deleteError = null
        },
        async deleteEvent() {
            this.deleting = true
            this.$apollo
                .mutate({
                    mutation: gql`
                        mutation($id: Int!) {
                            deleteEvent(id: $id)
                        }
                    `,
                    variables: {
                        id: this.id,
                    },
                })
                .then(() => {
                    this.deleting = false
                    this.deleteModalOpen = false
                    this.$router.replace({ path: '/events', query: { reload: true } })
                })
                .catch(err => {
                    let errMsg = err.message
                    try {
                        errMsg = err.graphQLErrors[0].message
                    } catch (e) {
                        //
                    }
                    try {
                        errMsg = err.networkError.result.errors[0].message
                    } catch (e) {
                        //
                    }
                    this.deleting = false
                    this.deleteError = errMsg
                })
        },
    },
    apollo: {
        getEvent: {
            query: EVENT_QUERY,
            variables() {
                return {
                    id: this.id,
                }
            },
        },
    },
    data() {
        return {
            deleting: false,
            deleteModalOpen: false,
            deleteError: null,
            id: parseInt(this.$route.params.id),
        }
    },
}
</script>
